import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import LocationSection from "@/sections/LocationSection";
import FaqSection from "@/sections/FaqSection";
import { localBusiness } from "@/lib/schema";
import { useSettings } from "@/context/SettingsContext";

export default function Contact() {
  const settings = useSettings();
  return (
    <>
      <Seo
        title="İletişim | Meguiar's İzmit"
        description="Meguiar's İzmit ile iletişime geçin. Telefon, WhatsApp, adres ve yol tarifi. Ücretsiz randevu için bize ulaşın."
        canonicalPath="/iletisim"
        jsonLd={localBusiness(settings)}
      />
      <PageHero
        overline="İletişim"
        title="Bize ulaşın"
        subtitle="Ücretsiz randevu için bize ulaşın. Aracınız için en doğru koruma planını birlikte belirleyelim."
        breadcrumbs={[{ label: "Ana Sayfa", to: "/" }, { label: "İletişim" }]}
        compact
      />
      <LocationSection />
      <FaqSection />
    </>
  );
}
